module.exports = __webpack_public_path__ + "static/sui-button-vertically-attached-d35d670243b26885bbe72d7087b91b52.png";